"use strict";
function stubArray() {
    return [];
}
module.exports = stubArray;
//# sourceMappingURL=stubArray.js.map